import { atomWithReset } from "jotai/utils";

export type ReferenceMeasurementInputValueModalState =
  | "open"
  | "closed"
  | "cancelled"
  | "confirmed";
export const referenceMeasurementInputValueModalStateAtom =
  atomWithReset<ReferenceMeasurementInputValueModalState>("closed");
